import CompanyBranch from "../../domain/CompanyBranch.entity";

class BranchesResponse {
  constructor(response = {}) {
    this.branches = response.data.items.map(branch => new CompanyBranch(branch));
  }
}

export default BranchesResponse;
